var CAT_VALUE = 'liquid';
/**
 * 获取水波图数据
 */
export function getLiquidData(percent) {
    return [{ percent: percent, type: CAT_VALUE }];
}
//# sourceMappingURL=utils.js.map